import React from "react";
import { Button, Form, Input, InputNumber, message } from "antd";
import Banner from "../../components/Banner";
import axios from "../../utils/request";
import { useNavigate } from "react-router-dom";
import { en, ch } from "../../utils/content";
import "./index.css";

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 16 },
};

/* eslint-disable no-template-curly-in-string */
const validateMessages = {
  required: "${label} is required!",
  types: {
    email: "${label} is not a valid email!",
  },
};

const LeaveWordPage = () => {
  const navigate = useNavigate();
  /* eslint-enable no-template-curly-in-string */
  const onFinish = async (values: any) => {
    if (values?.user?.name) {
      const res: any = await axios.post("/index/leaveMessage/add", {
        ...values.user,
        source: sessionStorage.getItem("lang"),
      });
      if (res.code === 200) {
        message.success("留言成功");
        navigate("/");
      }
    }
  };
  const lang = sessionStorage.getItem("lang") || "ch";
  const TXT_INFO = lang === "en" ? en : ch;
  return (
    <div className="leave-word">
      <Banner />
      <div className="container">
        <div className="title">{TXT_INFO.leaveWord.message}</div>
        <Form
          {...layout}
          name="nest-messages"
          onFinish={onFinish}
          style={{ maxWidth: 600 }}
          validateMessages={validateMessages}
        >
          <Form.Item
            name={["user", "name"]}
            label={TXT_INFO.leaveWord.name}
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={["user", "phone"]}
            label={TXT_INFO.leaveWord.phone}
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={["user", "email"]}
            label={TXT_INFO.leaveWord.email}
            rules={[{ type: "email", required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={["user", "address"]}
            label={TXT_INFO.leaveWord.address}
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={["user", "title"]}
            label={TXT_INFO.leaveWord.title}
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={["user", "content"]}
            label={TXT_INFO.leaveWord.content}
            rules={[{ required: true }]}
          >
            <Input.TextArea />
          </Form.Item>
          <Form.Item
            className="btn"
            wrapperCol={{ ...layout.wrapperCol, offset: 4 }}
          >
            <Button type="primary" htmlType="submit">
              提交
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default LeaveWordPage;
